import accountVerification from './Index';

export default [
  {
    path: '/accountverification',
    name: 'accountverification',
    component: accountVerification,
    props: false
  }
];